import React, { useState } from 'react';
import { useApp } from '../../context/AppContext';

export default function Login() {
  const { login } = useApp();
  const [email,    setEmail]    = useState('');
  const [password, setPassword] = useState('');
  const [error,    setError]    = useState('');
  const [loading,  setLoading]  = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password);
    } catch (err) {
      // Laravel validation errors are in err.response.data.message
      setError(
        err.response?.data?.message ||
        err.message ||
        'Invalid email or password'
      );
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="login-ov">
      <div className="login-box">
        <div style={{ textAlign:'center', marginBottom:24 }}>
          <div style={{ fontFamily:"'Cormorant Garamond',serif", fontSize:28, fontWeight:700, color:'#c47c3a', marginBottom:4 }}>
            Tayst
          </div>
          <div style={{ fontSize:11, color:'#9ca3af', letterSpacing:'.12em', textTransform:'uppercase' }}>
            Content Studio
          </div>
        </div>

        {error && <div className="login-err" style={{ display:'block' }}>{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="f-row">
            <div className="f-lbl">Email</div>
            <input className="f-inp" type="email" placeholder="you@taystcoffee.com"
              value={email} onChange={e => setEmail(e.target.value)} required autoFocus />
          </div>
          <div className="f-row">
            <div className="f-lbl">Password</div>
            <input className="f-inp" type="password" placeholder="••••••••"
              value={password} onChange={e => setPassword(e.target.value)} required />
          </div>
          <button className="btn btn-primary" type="submit" disabled={loading}
            style={{ width:'100%', justifyContent:'center', marginTop:8, padding:'9px 0' }}>
            {loading ? <>Signing in <span className="dots"><i/><i/><i/></span></> : 'Sign In'}
          </button>
        </form>

        <div style={{ marginTop:16, fontSize:10.5, color:'#9ca3af', textAlign:'center', lineHeight:1.6 }}>
          Use your Tayst account credentials.
        </div>
      </div>
    </div>
  );
}
